module.exports = __webpack_public_path__ + "assets/img/33_1467.28719805.jpg";